<template>
  <div class="slastContactedForm">
    <div class="row">
      <div class="col-12">
        <checkboxinput
          v-model="hasLastContacted"
          :title="$t('volunteerForm.lastContactedCheckBoxTitle')"
          :aria-label="$t('volunteerForm.lastContactedCheckBoxTitle')"
          @input="update"
        />
      </div>
    </div>

    <div v-if="hasLastContacted" class="row feature-panel">
      <div class="col-12">
        <datepicker
          :disabled="inActive"
          data-vv-scope="lastContactedForm"
          v-model="lastContacted"
          :title="$t('volunteerForm.lastContacted')"
          name="onIdentProfileForm.lastContacted"
          :is-valid="!errors.has('onIdentProfileForm.lastContacted')"
          @input="update"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue'
  import forminput from '../SPRSimpleText.vue'
  import checkboxinput from '../SPRSimpleCheckbox.vue'
  import datepicker from '../SPRSimpleDatepicker.vue'
  import { debounce } from 'lodash'
  

  interface TemplateComponentData {
    hasLastContacted: boolean,
    inActive: boolean,
    lastContacted: Object | undefined
  }
  export default Vue.extend({
    name: 'LastContactedForm',
    components: {
      forminput,
      checkboxinput,
      datepicker
    },
    inject: ['$validator'],
    data (): TemplateComponentData {
      return {
        hasLastContacted: false,
        inActive: false,
        lastContacted: undefined
      }
    },
    props: {
      value: {
        type: Object,
        required: true
      }
    },
    mounted (): void {
      this.hasLastContacted = this.value !== null
      this.lastContacted = this.value
    },
    methods: {
      update (): void {
        if (this.hasLastContacted && !this.lastContacted) {
          this.lastContacted = new Date()
        }
        this.$emit('input', this.hasLastContacted, this.lastContacted)
      }
    },
    created () {
      this.update = debounce(this.update, 300)
    }
  })
</script>

<style lang="scss">
@import "../../assets/scss/_variables.scss";

.lastContactedform {
  background-color: $brand-white;

  .subheader {
    color: $brand-red;
    text-transform: uppercase;
    font-family: $font-bold;
    margin: 0 0 10px 20px;
    display: block;
    font-size: 14px;
  }

  .sectionheader {
    margin: 15px 0;
  }
}
</style>